import React, { useContext, useState } from "react";
import { Button, Modal, Form, Row, Col } from "react-bootstrap";
import { Navigate } from "react-router-dom";
import { Notyf } from "notyf";
import UserContext from "../context/UserContext";
import { useCart } from "../context/CartContext";

export default function ProductDetails({ product, onClose }) {
  const { user } = useContext(UserContext);
  const { addToCart } = useCart();

  const [showPrompt, setShowPrompt] = useState(false);
  const [redirectToLogin, setRedirectToLogin] = useState(false);
  const [quantity, setQuantity] = useState(1);

  const notyf = new Notyf();

  const handleAddToCart = async () => {
    if (!user?.id) {
      setShowPrompt(true);
      return;
    }

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/cart/add-to-cart`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
          body: JSON.stringify({
            productId: product._id,
            price: product.price,
            quantity: Number(quantity),
            subtotal: product.price * Number(quantity),
          }),
        },
      );

      if (!response.ok) {
        throw new Error(`API returned ${response.status}`);
      }

      const data = await response.json();

      if (data.cart) {
        addToCart(data.cart.cartItems, data.cart.totalPrice);

        notyf.success("Added to your cart!");
        onClose();
      } else {
        notyf.error(data.message || "Unable to add product to cart.");
      }
    } catch (error) {
      console.error("Error adding to cart:", error);
      notyf.error("Failed to add product to cart.");
    }
  };

  const handleRedirectToLogin = () => {
    setShowPrompt(false);
    setRedirectToLogin(true);
  };

  const handleClosePrompt = () => {
    setShowPrompt(false);
  };

  const handleQuantityChange = (e) => {
    const value = Math.max(1, Number(e.target.value));
    setQuantity(value);
  };

  if (redirectToLogin) {
    return <Navigate to="/login" />;
  }

  return (
    <>
      {/* Product Details Modal */}
      <Modal
        show={true}
        onHide={onClose}
        centered
        size="lg"
        className="product-details-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>{product.name}</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Row className="g-4 align-items-center">
            {/* Product Image */}
            <Col xs={12} md={5}>
              <div className="product-details-image-wrapper">
                <img
                  src={product.imageUrl || "/placeholder-image.jpg"}
                  alt={product.name}
                  className="product-details-image"
                />
              </div>
            </Col>

            {/* Product Information */}
            <Col xs={12} md={7}>
              <div className="product-details-info">
                <span className="section-eyebrow">DESSERT HAVEN</span>

                <h2>{product.name}</h2>

                <p className="product-details-description">
                  {product.description}
                </p>

                <p className="product-details-price">PhP {product.price}</p>

                {/* Quantity */}
                <Form.Group controlId="quantity" className="product-quantity">
                  <Form.Label>Quantity</Form.Label>

                  <Form.Control
                    type="number"
                    min="1"
                    value={quantity}
                    onChange={handleQuantityChange}
                  />
                </Form.Group>

                {/* Add to Cart */}
                <Button
                  className="dh-button product-add-button"
                  onClick={handleAddToCart}
                >
                  Add to Cart
                </Button>
              </div>
            </Col>
          </Row>
        </Modal.Body>
      </Modal>

      {/* Login Prompt */}
      <Modal
        show={showPrompt}
        onHide={handleClosePrompt}
        centered
        className="login-required-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>Login Required</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <p>
            Please log in to your account before adding desserts to your cart.
          </p>
        </Modal.Body>

        <Modal.Footer>
          <Button className="dh-button" onClick={handleRedirectToLogin}>
            Login
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
